import { Component, Input } from '@angular/core';
import { ITypeNameAndDescription } from 'src/app/core/interfaces/onboarding/dashboard/type-name-and-description.interface';

@Component({
  selector: 'app-client-additional-info-request-list',
  templateUrl: './client-additional-info-request-list.component.html',
  styleUrls: ['./client-additional-info-request-list.component.scss'],
})
export class ClientAdditionalInfoRequestListComponent {
  @Input() typeNameAndDescriptionList: ITypeNameAndDescription[];
}
